// Add your custom JS here.

(function ($) {
  $(document).ready(function ($) {
    //rotate chevron on submenu
    $('.dropdown-item').hover(
      function () {
        $('.dropdown-toggle-chev').addClass('active');
      },
      function () {
        $('.dropdown-toggle-chev').removeClass('active');
      }
    );

    //invert toggler colour
    $('.navbar-toggler').click(function () {
      $(this).toggleClass('collapsed');
    });

    //tabs for category posts (show first tab active)
    $('#myTab li:nth-of-type(1) a').tab('show');

    //hero fades etc
    //removed jan24 hiding 24-39
    // $(window).load(function () {
    //   $('.hero-content-container').delay(1500).addClass('fade-up');
    // });

    // display reading estimate on each post if needed
    // Countable.count($('.article-body')[0], function (counter) {
    //   var wpm = 200,
    //       estimatedRaw = counter.words / wpm,
    //       minutes = Math.round(estimatedRaw);

    //   var effectiveTime = (minutes < 1) ? "less than 1 min read" : minutes + " min read";

    //   //display it
    //   $('.reading-time').html(effectiveTime);
    // });

    // display reading estimate on our-impact page
    $('.article-body').each(function () {
      var articleBody = this;
      Countable.count(articleBody, function (counter) {
        var wpm = 200,
          estimatedRaw = counter.words / wpm,
          minutes = Math.round(estimatedRaw);

        var effectiveTime =
          minutes < 1 ? 'less than 1 min read' : minutes + ' min read';

        // Select the closest .reading-time element to the current article body
        $(articleBody)
          .closest('.post-card')
          .find('.reading-time')
          .html(effectiveTime);
        $('.post-card .acf-field').hide();
      });
    });
  });
})(jQuery);

/* FADES
//removed jan24 hiding 67-94
–––––––––––––––––––––––––––––––––––––––––––––––––– */

// Add event listener to window object to detect scrolling
// window.addEventListener('scroll', function () {
//   const elementsToAnimate = document.querySelectorAll('.fade-in');

//   // Loop through selected elements and check if they are in the viewport
//   elementsToAnimate.forEach((element) => {
//     if (isElementInViewport(element)) {
//       // Add 'is-visible' class to element if it's in the viewport
//       element.classList.add('is-visible');
//     }
//   });
// });

// Function to check if an element is in the viewport
// function isElementInViewport(element) {
//   const rect = element.getBoundingClientRect();
//   const windowHeight =
//     window.innerHeight || document.documentElement.clientHeight;
//   const windowWidth = window.innerWidth || document.documentElement.clientWidth;

//   // Return true if the element is in the viewport, false otherwise
//   return (
//     rect.top >= 0 &&
//     rect.left >= 0 &&
//     rect.bottom <= windowHeight &&
//     rect.right <= windowWidth
//   );
// }
